// extracted by mini-css-extract-plugin
module.exports = {"btn":"solid_btn__135f7","external":"solid_external__3bY-c","btn_inactive":"solid_btn_inactive__1fDMb","narrow":"solid_narrow__2jIY7"};